import { render, staticRenderFns } from "./IpAddressTable.vue?vue&type=template&id=5d65ab77&scoped=true"
import script from "./IpAddressTable.vue?vue&type=script&setup=true&lang=ts"
export * from "./IpAddressTable.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./IpAddressTable.vue?vue&type=style&index=0&id=5d65ab77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d65ab77",
  null
  
)

export default component.exports